import { render, staticRenderFns } from "./pogs-form__item--pregnancy-postpartum.vue?vue&type=template&id=2a2834a2&scoped=true&"
import script from "./pogs-form__item--pregnancy-postpartum.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--pregnancy-postpartum.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--pregnancy-postpartum.vue?vue&type=style&index=0&id=2a2834a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2834a2",
  null
  
)

export default component.exports